import { Link } from "react-router-dom";
import { memo } from "react";
import { useHomePath } from "../navigation/navigationConfig";

const BrandLogo = memo(({ to }) => {
  const homePath = useHomePath();

  return (
    <Link to={to || homePath} className="navbar-brand fw-bold d-flex align-items-center" aria-label="Swarand Home">
      <span className="brand-wordmark">Swarand</span>
    </Link>
  );
});

BrandLogo.displayName = 'BrandLogo';

export default BrandLogo;
